import { render, staticRenderFns } from "./RetailerGroupModalDeactivateRetailer.vue?vue&type=template&id=18a554e9&"
import script from "./RetailerGroupModalDeactivateRetailer.vue?vue&type=script&lang=ts&"
export * from "./RetailerGroupModalDeactivateRetailer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports